import { createEntityAdapter, createSelector, createSlice, EntityState, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../store'
import { InputParametersHierarchyNodeByPresets } from '../../models/InputParametersHierarchy'
import { selectSelectedMeetingTemplate } from './meetingTemplates'

interface InputParametersForMeetingTemplate {
  meetingTemplateId: string
  inputParametersHierarchyNodeByPresets: InputParametersHierarchyNodeByPresets
}

interface InputParametersHierarchyState {
  isLoading: boolean
  inputParametersByMeetingTemplate: EntityState<InputParametersForMeetingTemplate, string>
}

const inputParametersHierarchyAdapter = createEntityAdapter<InputParametersForMeetingTemplate, string>({ selectId: (model) => model.meetingTemplateId })

const initialState: InputParametersHierarchyState = {
  isLoading: true,
  inputParametersByMeetingTemplate: inputParametersHierarchyAdapter.getInitialState(),
}

export const inputParametersHierarchySlice = createSlice({
  name: 'inputParametersHierarchy',
  initialState,
  reducers: {
    setInputParametersHierarchyLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload
    },
    setInputParametersHierarchyForMeetingTemplate: (state, action: PayloadAction<InputParametersForMeetingTemplate>) => {
      inputParametersHierarchyAdapter.setOne(state.inputParametersByMeetingTemplate, action.payload)
    },
    resetInputParametersHierarchy: () => initialState,
  },
})

export const { setInputParametersHierarchyLoading, setInputParametersHierarchyForMeetingTemplate, resetInputParametersHierarchy } =
  inputParametersHierarchySlice.actions

const inputParametersHierarchyByMeetingTemplateSelectors = inputParametersHierarchyAdapter.getSelectors(
  (state: RootState) => state.meetingSummary.inputParametersHierarchy.inputParametersByMeetingTemplate,
)

export const selectInputParametersHierarchyForSelectedMeetingTemplate = createSelector(
  [(state: RootState) => state, selectSelectedMeetingTemplate],
  (state, selectedMeetingTemplate) => {
    if (!selectedMeetingTemplate) {
      return null
    }
    const inputParametersHierarchyForSelectedMeetingTemplate = inputParametersHierarchyByMeetingTemplateSelectors.selectById(state, selectedMeetingTemplate.id)
    return inputParametersHierarchyForSelectedMeetingTemplate ?? null
  },
)
